
import React from 'react';
import moment from "moment";

import * as commonFunc from 'scripts/common';
import Swal from "sweetalert2";

import ToolbarDate from 'components/ToolbarDate';
import CChart from 'components/CChart';

import CDataTable from "components/CDataTable";

import {
    Label,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    CardTitle
} from "reactstrap";

const StatsLead = React.forwardRef(({ leadModels, filters, hideToolbarDate, /*JSON ARGS*/ globalKey, showGlobalCard, objType, configs, periods, itemsLabel = "Éléments", slicerValue = 20 }, ref) => {

    const [displayStats, setDisplayStats] = React.useState(false);

    const [curDate, setCurDate] = React.useState(moment().format());
    const [endDate, setEndDate] = React.useState(moment().endOf("year").format());
    const [curPeriod, setCurPeriod] = React.useState("*");

    const [statsGlobalObj, setStatsGlobalObj] = React.useState();
    const [statsList, setStatsList] = React.useState();

    React.useEffect(() => {
        if (globalKey) getGlobalStats();
    }, [filters?.groupFilter, filters?.assignSiteFilter, filters?.serviceFilter]);

    React.useEffect(() => {
        getStats();
    }, [curPeriod, curDate, endDate, filters?.groupFilter, filters?.assignSiteFilter, filters?.serviceFilter]);


    React.useImperativeHandle(ref, () => ({
        isDisplayStats: () => displayStats,
        displayStats: () => {
            setDisplayStats(!displayStats);
        },
        getGlobalStats: () => statsGlobalObj
    }));


    function getGlobalStats() {
        setStatsGlobalObj(null);
        /*Swal.fire({
            title: props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
        });*/

        var args = { extraKey: globalKey, categ: "STATUS_EXTID", categoryId: -1, period: "*" };

        if (filters?.groupFilter > 0) args.groupId = filters?.groupFilter;
        if (filters?.assignSiteFilter > 0) args.siteId = filters?.assignSiteFilter;
        if (filters?.serviceFilter > 0) args.serviceId = filters?.serviceFilter;
        if (filters?.categoryGroupKey) args.categoryGroupKey = filters?.categoryGroupKey;

        commonFunc.getMethod("../api/data/GetLeadSummary", args).then(response => {
            const dataStats = response.data;
            if (dataStats.isSuccess) {
                var statusSummary = dataStats.result;
                var statsObj = { count: 0 };

                statusSummary.forEach(obj => {
                    statsObj.count += obj.totalCount;
                    switch (obj.id) {
                        case 3005: statsObj.successCount = obj.totalCount; break;
                        case 3006: statsObj.loseCount = obj.totalCount; break;
                        case 3008: statsObj.waitingCount = obj.totalCount; break;
                        case 3001:
                        case 3002:
                        case 3003:
                        case 3004:
                        case 3007:
                        case 3009:
                            if (!statsObj.activeCount) statsObj.activeCount = 0;
                            statsObj.activeCount += obj.totalCount;
                            break;
                        default:
                            break;
                    }
                });

                setStatsGlobalObj(statsObj);
            }
        });
    }

    function getStats() {
        setStatsList(null);
        /*Swal.fire({
            title: props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
        });*/

        var asyncJobs = [];

        configs.forEach(cfg => {
            var args = { ...cfg, startDate: curDate, period: curPeriod, endDate: endDate };
            delete args.cRowTag;
            delete args.cChartCfg;
            delete args.cTableCfg;

            if (filters?.groupFilter > 0) args.groupId = filters?.groupFilter;
            if (filters?.assignSiteFilter > 0) args.siteId = filters?.assignSiteFilter;
            if (filters?.serviceFilter > 0) args.serviceId = filters?.serviceFilter;
            if (filters?.categoryGroupKey) args.categoryGroupKey = filters?.categoryGroupKey;

            asyncJobs.push(commonFunc.getMethod("../api/data/GetLeadSummary", args).then((async response => {
                if (response.data) response.data.dataTarget = cfg.cChartCfg ? cfg.cChartCfg.dataTarget : cfg.cTableCfg.dataTarget;
                if (cfg.cChartCfg?.dataSort) {
                    switch (cfg.cChartCfg?.dataSort) {
                        case "name+id":
                            response.data.result = response.data.result.sort((a, b) => {
                                if (a.name === b.name) {
                                    return a.id - b.id;
                                }
                                return parseInt(a.name) - parseInt(b.name);
                            });
                            break;
                        default: break;
                    }
                }
                return new Promise(resolve => {
                    resolve(response);
                });
            })).catch(error => {
                return new Promise((resolve) => {
                    resolve({ isSuccess: false, errorMessage: error });
                });
            }));
        });

        Promise.all(asyncJobs).then(results => {
            var err = 0;
            var sum = 0;
            var msgErr = "";

            var resultList = {};
            for (var i = 0; i < results.length; i++) {
                if (results[i] && results[i].data && results[i].data.isSuccess) {
                    sum += 1;
                    // resStr += dataAll[i].result.first_last_name + " " + dataAll[i].result.last_name + '/';
                    resultList[results[i].data.dataTarget] = results[i].data.result;
                } else {
                    err += 1;
                    if (results[i] && results[i].data) {
                        msgErr += i + " " + results[i].data.errorMessage + "\n";
                    } else {
                        msgErr += i + "\n";
                    }
                }
            }
            Swal.close();

            setStatsList(resultList);
            if (err === 0) {

            } else {
                var tot = 0;
                tot = err + sum;
                if (tot === configs.length) {
                    Swal.fire({
                        icon: "error",
                        title: "Echec",
                        html: "Echec de la récupération de certaines stats (" + err + "/" + sum + ") :<br>" + msgErr
                    });
                }
            }
        }, rej => {
            Swal.fire({
                icon: "error",
                title: "Erreur",
                html: "Erreur de la récupération des stats :<br>" + rej.message
            });
        }).catch(error => {
            Swal.fire({
                icon: "error",
                title: "Erreur",
                html: "Erreur de la récupération des stats :<br>" + error.message
            });
        });


    }

    /****** GESTION DATE (ToolbarDate) ******/

    function selPreviousPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().subtract(1, 'days');
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().startOf('month').subtract(1, 'days').startOf('month');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().startOf('year').subtract(1, 'days').startOf('year');
                break;
            default: break;
        }
        if (begin) {
            //setCurDate(begin.startOf('day').format());
            setCurDate(begin.utc(true).startOf('day').format());
        }
    }

    function datepickerChange(date, endChange) {
        if (!date) date = moment(curDate);

        if (!endChange) setCurDate(date.format());
        else setEndDate(date.format());
    }



    function selNextPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().add(1, 'days')
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().endOf('month').add(1, 'days');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().endOf('year').add(1, 'days');
                break;
            default: break;
        }
        if (begin) {
            //setCurDate(begin.startOf('day').format());
            setCurDate(begin.utc(true).startOf('day').format());
        }
    }

    function getFormattedDate() {
        switch (curPeriod) {
            case "D": return moment(curDate).format("dddd DD MMMM YYYY");
            case "L": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').subtract(2, 'days').format("ddd DD MMMM YYYY [(S]W[)]");
            case "W": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]");
            case "M": return moment(curDate).startOf('month').format("ddd DD MMMM YYYY") + " au " + moment(curDate).endOf('month').format("ddd DD MMMM YYYY");
            case "Y": return "Année " + moment(curDate).startOf('year').format("YYYY");
            case "C": return "Saisie Manuelle";
            case "*": return "Toutes Périodes";
            default: return "";
        }
    }

    /****** FIN GESTION DATE (ToolbarDate) ******/


    var altConfigs = {};
    if (periods) altConfigs.cPeriods = periods;
    altConfigs.updatePeriod = setCurPeriod;

    var cbObj = {
        sliceValue: function (val, index) {
            // Hide every 2nd tick label
            var label = this.getLabelForValue(val);
            return (label.length > slicerValue ? (label.slice(0, slicerValue) + ".") : label);
        }
    };

    var rowConfigs = {};
    configs?.forEach((cfg) => {
        if (!rowConfigs[cfg.cRowTag]) rowConfigs[cfg.cRowTag] = [];
        rowConfigs[cfg.cRowTag].push(cfg);
    });

    return <>
        {(globalKey && showGlobalCard) ? <Card className="leads-stats w-100">
            <CardBody>
                <Row>
                    <Col onClick={() => { setDisplayStats(!displayStats); }}>
                        <Label>Total {itemsLabel}</Label>
                        <Label>{statsGlobalObj?.count || 0}</Label>
                    </Col>
                    <Col onClick={() => { setDisplayStats(!displayStats); }}>
                        <Label>Succès</Label>
                        <Label>{statsGlobalObj?.successCount || 0}</Label>
                    </Col>
                    <Col onClick={() => { setDisplayStats(!displayStats); }}>
                        <Label>Perdu</Label>
                        <Label>{statsGlobalObj?.loseCount || 0}</Label>
                    </Col>
                    <Col onClick={() => { setDisplayStats(!displayStats); }}>
                        <Label>En attente</Label>
                        <Label>{statsGlobalObj?.waitingCount || 0}</Label>
                    </Col>
                    <Col onClick={() => { setDisplayStats(!displayStats); }}>
                        <Label>En cours</Label>
                        <Label>{statsGlobalObj?.activeCount || 0}</Label>
                    </Col>
                </Row>
            </CardBody>
        </Card> : ""}
        {displayStats ? <div className="stats-details">
            {!hideToolbarDate ? <ToolbarDate refreshContent={getStats} customTitle={getFormattedDate()} hideRefresh={true}
                currentPeriod={curPeriod}
                selPreviousPeriod={selPreviousPeriod}
                datepickerChange={datepickerChange}
                selNextPeriod={selNextPeriod}
                datepickerOpt={{ showWeeks: true, initialValue: moment(new Date()).utc().toDate(), initialEndValue: moment().endOf("year").endOf("day").toDate() }}
                customAddBtn={<div className="d-none"></div>} {...altConfigs}></ToolbarDate> : ""}

            <div className="charts-container">
                {!statsList ? <div className="text-center"><i className="fa fa-circle-notch fa-spin fa-xl"></i></div> : ""}
                {Object.keys(rowConfigs).map((rowCfgKey => {
                    return <Row className={`tag-${rowCfgKey}`}>
                        {rowConfigs[rowCfgKey].map(cfg => {
                            //Gestion function
                            var dataSrc;
                            if (cfg.cChartCfg) {
                                if (cfg.cChartCfg.chartOptions?.scales?.x?.ticks?.cCallbackTag) cfg.cChartCfg.chartOptions.scales.x.ticks.callback = cbObj[cfg.cChartCfg.chartOptions.scales.x.ticks.cCallbackTag];

                                //Gestion data source
                                dataSrc = statsList ? statsList[cfg.cChartCfg.dataTarget] : null;
                                if (dataSrc) {
                                    //Construction data chart.js
                                    var dataObj;
                                    if (cfg.cChartCfg.stacked) {
                                        dataObj = {
                                            labels: (() => {
                                                var labelList = {};
                                                dataSrc.forEach(obj => { labelList[obj.refName] = true; });
                                                return Object.keys(labelList);
                                            })(),
                                            datasets: (() => {
                                                var datasetList = {};

                                                //Création des datasets
                                                dataSrc.forEach(obj => {
                                                    if (!datasetList[obj.name]) { datasetList[obj.name] = { dataset: [], color: obj.altInfo, index: obj.sup_2, index2: obj.sup_1 }; }//TODO index
                                                });

                                                //Alimentation des datasets
                                                var lastName = null;
                                                var entityCount = 0;
                                                dataSrc.forEach(obj => {
                                                    if (lastName !== obj.refName) {
                                                        lastName = obj.refName;
                                                        if (entityCount > 0) {
                                                            //Alimentation des données vide dans les datasets restant
                                                            Object.keys(datasetList).forEach(dsKeyFill => {
                                                                var ds = datasetList[dsKeyFill];
                                                                if (ds.dataset.length < entityCount) ds.dataset.push(0);
                                                            });
                                                        }
                                                        entityCount++;
                                                    }
                                                    datasetList[obj.name].dataset.push(obj.totalCount);
                                                });
                                                //Alimentation des dernières données vide dans les datasets restant
                                                Object.keys(datasetList).forEach(dsKeyFill => {
                                                    var ds = datasetList[dsKeyFill];
                                                    if (ds.dataset.length < entityCount) ds.dataset.push(0);
                                                });

                                                return Object.keys(datasetList).sort((aKey, bKey) => {
                                                    var a = datasetList[aKey];
                                                    var b = datasetList[bKey];
                                                    if (a.index === b.index) {
                                                        return parseInt(a.index2) - parseInt(b.index2);
                                                    }
                                                    return parseInt(a.index) - parseInt(b.index);
                                                }).map(key => {
                                                    return {
                                                        "color": "#1A73E8",
                                                        "label": key,
                                                        "backgroundColor": datasetList[key].color,
                                                        "data": datasetList[key].dataset,
                                                        ...cfg.cChartCfg.dsProps
                                                    };
                                                });
                                            })()
                                        };
                                    }
                                    else {
                                        dataObj = {
                                            labels: dataSrc.map(obj => obj.refName),
                                            datasets: [
                                                {
                                                    "color": "#1A73E8",
                                                    "label": itemsLabel,
                                                    "backgroundColor": dataSrc.map(obj => obj.altInfo),
                                                    "data": dataSrc.map(obj => obj.totalCount),
                                                    ...cfg.cChartCfg.dsProps
                                                }
                                            ]
                                        };
                                    }

                                    return <Col>
                                        <Card className="w-100">
                                            <CardHeader>
                                                <CardTitle>{cfg.cChartCfg.title}</CardTitle>
                                            </CardHeader>
                                            <CardBody><CChart type={cfg.cChartCfg.type} redraw
                                                className="d-inline-block align-top"
                                                style={{ width: "100%", height: "250px" }}
                                                data={dataObj}
                                                options={cfg.cChartCfg.chartOptions} />
                                            </CardBody>
                                        </Card>
                                    </Col>;
                                }
                                else return "";
                            }
                            else if (cfg.cTableCfg) {
                                //Gestion data source
                                dataSrc = statsList ? statsList[cfg.cTableCfg.dataTarget] : null;
                                if (dataSrc) {
                                    const dtModel = cfg.cTableCfg.dtModel;

                                    const dtConfig = {};

                                    var dataStamp = new Date().getTime();
                                    var srcRows = dataSrc;//[{ id: 1, name: "q2-A", refName: "0.95", sup_1: "1001" }];

                                    var optNb = {};
                                    var labelTab = cfg.cTableCfg.labelTab;
                                    if (objType === "surveystats") {
                                        var serviceModifier = filters?.serviceFilter > 0 ? "_" + filters?.serviceFilter : "";
                                        var groupModifier = filters?.groupFilter > 0 ? "_" + filters?.groupFilter : "";
                                        var leadModel = leadModels ? (leadModels["LEAD_SURVEY" + groupModifier + serviceModifier] || leadModels["LEAD_SURVEY" + serviceModifier]) : null;

                                        //TODO : Voir si gestion de plusieurs service...
                                        var serviceID = filters?.serviceFilter;

                                        labelTab = {};
                                        leadModel.templates.forEach(template => {
                                            template.categories.forEach(category => {
                                                category.headers.forEach(header => {
                                                    header.groups.forEach(group => {
                                                        var lastGroupLabel;
                                                        var lastLabel;
                                                        group.items.forEach(item => {
                                                            if (item.objType === "textview") {
                                                                lastLabel = item.title;
                                                                if (group.items.length === 3 && item.title?.indexOf("•") >= 0) lastGroupLabel = item.title;
                                                            }
                                                            if (item.bindPropResult?.toLowerCase().startsWith("extras.") && item.objType === "radio") {
                                                                var targetKey = item.bindPropResult.replace("Extras.", "").replace("extras.", "");
                                                                targetKey = targetKey.charAt(0).toLowerCase() + targetKey.slice(1);
                                                                if (lastGroupLabel) {
                                                                    if (!labelTab[serviceID]) labelTab[serviceID] = {};
                                                                    labelTab[serviceID][targetKey.split("-")[0]] = lastGroupLabel;
                                                                }
                                                                if (lastLabel) {
                                                                    if (!labelTab[serviceID]) labelTab[serviceID] = {};
                                                                    labelTab[serviceID][targetKey] = lastLabel;
                                                                }

                                                                if (!optNb[serviceID]) optNb[serviceID] = {};
                                                                optNb[serviceID][targetKey] = (item.options?.length || 0);

                                                                lastLabel = null;
                                                            } 
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                        labelTab = commonFunc.mergeDeep({}, labelTab, cfg.cTableCfg.labelTab); //Override labels
                                    }

                                    var groupedRows = [];
                                    srcRows.forEach(row => {
                                        var curRow;
                                        var subVal;
                                        var containRow = groupedRows.filter(gRow => gRow.name === row.name);
                                        if (containRow.length) {
                                            curRow = containRow[0];

                                            var existingVal = curRow.values.filter(subVal => subVal.value === row.refName);
                                            if (existingVal?.length) {
                                                subVal = existingVal[0];
                                                subVal.count += row.totalCount;
                                            }
                                            else {
                                                subVal = { count: row.totalCount, value: row.refName };
                                                curRow.values.push(subVal);
                                            }
                                        }
                                        else {
                                            subVal = { count: row.totalCount, value: row.refName };
                                            curRow = { ...row, values: [subVal] };
                                            delete curRow.refName;
                                            curRow.totalCount = 0;
                                            curRow.optCount = optNb[row.id] ? (optNb[row.id][row.name] || 0) : 0;
                                            groupedRows.push(curRow);
                                        }

                                        //Test valeur spécifiques
                                        if (!(parseInt(row.refName) === 8192 || parseInt(row.refName) === 0)) curRow.totalValue += row.totalCount;

                                        if (curRow.optCount > 0 && curRow.optCount <= 4) {//Vérification du nombre d'option pour définir "Niveau Satisf." OU "Oui/Non" (<=4)
                                            subVal.isBool = true;
                                            if (parseInt(row.refName) === 4) {//Détermine si on le gère dans la progressbar ou non
                                                curRow.totalCount += row.totalCount;//Oui
                                                subVal.isProgress = true;
                                                subVal.isMax = true;
                                            }
                                        }
                                        else if (parseInt(row.refName) === 16 || parseInt(row.refName) === 8) {//Détermine si on le gère dans la progressbar ou non
                                            curRow.totalCount += row.totalCount;//Très+Satisfaisant
                                            subVal.isProgress = true;
                                            subVal.isMax = parseInt(row.refName) === 16;
                                        }
                                    });

                                    console.debug(groupedRows.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())));

                                    var globalRow, recommandationRow;
                                    var filteredRows = groupedRows.map((row, index) => {
                                        if (labelTab && labelTab[row.id] && labelTab[row.id][row.name]) {
                                            var labelTabName = labelTab[row.id][row.name];
                                            if (!labelTabName.startsWith("Globalement") && !labelTabName.startsWith("Recommanderiez-vous")) {
                                                return { id: index, name: (labelTabName || row.name), tag: row.name, srcId: row.id, percent: (parseInt(row.totalCount) / parseInt(row.totalValue)) || 0, optionsLength: row.optCount, count: row.totalValue, values: row.values };
                                            }
                                            else {
                                                if (labelTabName.startsWith("Globalement")) globalRow = row;
                                                if (labelTabName.startsWith("Recommanderiez-vous")) recommandationRow = row;
                                                return null;
                                            }
                                        }
                                        else return null;
                                    }).filter(row => row != null);

                                    //functionPanel={dtFunctionPanel}

                                    //return <CDataTable key={"stats" + objType} dtId={"tableStats" + objType} data={filteredRows} localConfig={dtConfig} tag={"DT_CARSSTATS"} config={dtModel} stamp={dataStamp}
                                    //    className={`table-striped table-hover nowrap`} style={{ fontSize: "90%" }} />;

                                    var lastGroup;
                                    return <div className="stats-progress-container mb-2">
                                        {globalRow ? <div className="d-flex">
                                            <div className="fw-bold" style={{ flex: "auto" }}>
                                                <span className="fs-4" style={{ color: "#F68B1F" }}>{cfg.cTableCfg.title}</span>
                                                <div className="float-end badge text-white p-2 fs-6" style={{ backgroundColor: "#F68B1F" }}>
                                                    <div>Satisfaction globale</div>
                                                    <div className="mt-1">{(((parseInt(globalRow.totalCount) / parseInt(globalRow.totalValue)) || 0) * 100).toFixed(2)}%</div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                        {filteredRows.map((row) => {
                                            var currentGroup = row.tag.split("-")[0];
                                            var supGroup = "";
                                            if (!lastGroup || lastGroup !== currentGroup) {
                                                lastGroup = currentGroup;

                                                var groupLabel = labelTab[row.srcId][lastGroup] || "";
                                                var isBool = row.values?.length ? row.values[0].isBool : false;
                                                supGroup = <div>
                                                    <h6 className="text-success m-0 mt-3">{groupLabel}</h6>
                                                    <div className="d-flex">
                                                        <div className="w-50"></div>
                                                        {isBool ? <div className="fw-bold" style={{ flex: "auto" }}>
                                                            <span className="text-primary">Oui</span>
                                                            <span className="float-end text-primary bg-alpha">Non</span>
                                                        </div> : <div className="fw-bold" style={{ flex: "auto" }}>
                                                            <span className="text-success">Très satisfaisant</span>
                                                            <span className="float-end text-success bg-alpha">Satisfaisant</span>
                                                        </div>}
                                                        <span className="fw-bold ms-2 invisible">00.00%</span>
                                                    </div>
                                                </div>;
                                            }

                                            return (<>
                                                {supGroup}
                                                <div className="d-flex">
                                                    <div className="w-50">{row.name}</div>
                                                    <div className="progress" style={{ flex: "auto" }}>
                                                        {row.values.filter(valObj => valObj.isProgress).map(valObj => {
                                                            var progression = (valObj.count / row.count);
                                                            return <div className={`progress-bar ${valObj.isBool ? "bg-primary" : "bg-success"} ${valObj.isMax ? "" : "bg-alpha"}`} title={(progression * 100).toFixed(2) + "%"} role="progressbar" aria-valuenow={(progression * 100)} aria-valuemin="0" aria-valuemax="100" style={{ width: (progression * 100) + "%" }} ></div>;
                                                        })}
                                                    </div>
                                                    <span className="fw-bold ms-2">{(row.percent * 100).toFixed(2) + "%"}</span>
                                                </div>
                                            </>);
                                        })}
                                        {recommandationRow ? <div className="d-flex mt-2">
                                            <div className="fw-bold" style={{ flex: "auto" }}>
                                                <div className="badge text-white p-2 fs-6" style={{ backgroundColor: "#F68B1F"}}>
                                                    <div>Je recommande l'ADMR</div>
                                                    <div className="mt-1">{(((parseInt(recommandationRow.totalCount) / parseInt(recommandationRow.totalValue)) || 0) * 100).toFixed(2)}%</div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    </div>;


                                }
                                else return "";
                            }
                            else return "";
                        })}
                    </Row>;
                }))}
            </div>
        </div> : ""}
    </>;
});

export default StatsLead;